export default "__VITE_ASSET__BdeSItZL__"